var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.orderModalData.open
        ? _c("sideBarOrderModal", {
            attrs: {
              modalData: _vm.orderModalData,
              onModalClose: _vm.closeModal,
              fetchOrders: _vm.fetchOrders,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.blackListPhoneNum
        ? _c("PhoneBlackListEditModal", {
            attrs: {
              blackListPhoneNum: _vm.blackListPhoneNum,
              onCancel: _vm.closeBlackList,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sendLetterModalData
        ? _c("SendLetterModal", {
            attrs: {
              modalData: _vm.sendLetterModalData,
              onModalClose: _vm.closeModal,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "table",
        { staticClass: "table table-bordered1 table-hover orders_table" },
        [
          _c("thead", [
            _c("tr", [
              _vm.selectAll
                ? _c("th", [
                    _c("input", {
                      attrs: { type: "checkbox" },
                      on: {
                        change: function ($event) {
                          return _vm.updateSelected($event)
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.oldOrders ? _c("th") : _vm._e(),
              _vm._v(" "),
              _c("th", { staticClass: "w-90p" }, [
                _vm._v("\n        ID\n        "),
                _vm.sorting
                  ? _c("i", {
                      staticClass: "icon-fa",
                      class: {
                        "icon-fa-long-arrow-up": !_vm.sorting.id.sort,
                        "icon-fa-long-arrow-down": _vm.sorting.id.sort,
                        active: _vm.sorting.id.active,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateSorting("id")
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("hr"),
                _vm._v("\n        Создание\n      "),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "w-90p" }, [
                _vm._v("\n        Доставка\n        "),
                _vm.sorting
                  ? _c("i", {
                      staticClass: "icon-fa",
                      class: {
                        "icon-fa-long-arrow-up":
                          !_vm.sorting.delivery_date.sort,
                        "icon-fa-long-arrow-down":
                          _vm.sorting.delivery_date.sort,
                        active: _vm.sorting.delivery_date.active,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateSorting("delivery_date")
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("hr"),
                _vm._v("\n        Проект\n      "),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "w-12P" }, [_vm._v("Клиент")]),
              _vm._v(" "),
              _c("th", { staticClass: "w-20P" }, [_vm._v("Адрес")]),
              _vm._v(" "),
              _c("th", { staticClass: "hidden", attrs: { width: "130px" } }, [
                _vm._v("Телефон"),
              ]),
              _vm._v(" "),
              _c("th", [
                _vm._v("\n        Препараты\n        "),
                _vm.sorting
                  ? _c("i", {
                      staticClass: "icon-fa",
                      class: {
                        "icon-fa-long-arrow-up": !_vm.sorting.drug.sort,
                        "icon-fa-long-arrow-down": _vm.sorting.drug.sort,
                        active: _vm.sorting.drug.active,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateSorting("drug")
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "w-12p" }),
              _vm._v(" "),
              _c("th", { staticClass: "w-70p" }, [
                _vm._v("\n        Сумма\n        "),
                _vm.sorting
                  ? _c("i", {
                      staticClass: "icon-fa",
                      class: {
                        "icon-fa-long-arrow-up": !_vm.sorting.price.sort,
                        "icon-fa-long-arrow-down": _vm.sorting.price.sort,
                        active: _vm.sorting.price.active,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateSorting("price")
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              !_vm.disableEdit ? _c("th") : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.orders, function (order, index) {
              return order && !(order.visible === false)
                ? _c(
                    "tr",
                    {
                      key: order.id,
                      class: _vm.getClassByOrderStatus(order.status),
                    },
                    [
                      _vm.selectAll
                        ? _c("td", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selected[order.id].value,
                                  expression: "selected[order.id].value",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled: _vm.selected[order.id].disabled,
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.selected[order.id].value
                                )
                                  ? _vm._i(_vm.selected[order.id].value, null) >
                                    -1
                                  : _vm.selected[order.id].value,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.selected[order.id].value,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.selected[order.id],
                                          "value",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.selected[order.id],
                                          "value",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.selected[order.id],
                                      "value",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.oldOrders
                        ? _c("td", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selected[order.id],
                                  expression: "selected[order.id]",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.selected[order.id])
                                  ? _vm._i(_vm.selected[order.id], null) > -1
                                  : _vm.selected[order.id],
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.selected[order.id],
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.selected,
                                          order.id,
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.selected,
                                          order.id,
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.selected, order.id, $$c)
                                  }
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td", [
                        _c("p", [_vm._v(_vm._s(order.id))]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c("p", { staticClass: "text_date" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.moment(order.created_at, "DD.MM.YYYY")
                              ) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "text_date" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.printDate(order.created_at, "HH:mm")
                                ) +
                                "\n\n          "
                            ),
                            _vm.editComment
                              ? [
                                  _c("i", {
                                    staticClass:
                                      "comment_icon icon-fa icon-fa-commenting",
                                    on: {
                                      click: function ($event) {
                                        return _vm.openCommentModal(order)
                                      },
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            (order.comment &&
                              order.comment.length &&
                              !_vm.editComment) ||
                            order.reject_comment ||
                            (order.extra_options?.comments_for_runner ?? [])
                              .length
                              ? [
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: {
                                          content: _vm.getComments(order),
                                          placement: "bottom-center",
                                          classes: ["info custom-tooltip"],
                                          targetClasses: [
                                            "it-has-a-tooltip custom-tooltip",
                                          ],
                                          offset: 10,
                                          delay: {
                                            show: 200,
                                            hide: 700,
                                          },
                                        },
                                        expression:
                                          "{\n                  content: getComments(order),\n                  placement: 'bottom-center',\n                  classes: ['info custom-tooltip'],\n                  targetClasses: ['it-has-a-tooltip custom-tooltip'],\n                  offset: 10,\n                  delay: {\n                    show: 200,\n                    hide: 700\n                  }\n                }",
                                      },
                                    ],
                                    staticClass:
                                      "icon-fa icon-fa-info-circle comment_tooltip_fa",
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        order.is_reserved
                          ? _c("p", [
                              _c("span", { staticClass: "badge badge-info" }, [
                                _vm._v("В резерве"),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("p", { staticClass: "text_date" }, [
                            _vm._v(_vm._s(_vm.printOrderDate(order))),
                          ]),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  (_vm.$AllProjects[order.site_id] &&
                                    _vm.$AllProjects[order.site_id].title) ||
                                    order.project_label
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            order.site_mirror_id
                              ? _c(
                                  "span",
                                  { staticClass: "badge badge-danger" },
                                  [_vm._v(_vm._s(_vm.getMirrorName(order)))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            order.dialog_chat_bot_id
                              ? _c(
                                  "span",
                                  { staticClass: "badge badge-info" },
                                  [_vm._v("ЧатБот")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            order.site_source
                              ? _c(
                                  "span",
                                  { staticClass: "badge badge-info" },
                                  [_vm._v(_vm._s(order.site_source))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            order.type_id == 2
                              ? _c(
                                  "span",
                                  { staticClass: "order_type refund" },
                                  [
                                    _vm._v(
                                      "Возврат (" +
                                        _vm._s(order.related_order_id) +
                                        ")"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            order.extra_options &&
                            order.extra_options.byAgentReSeller
                              ? _c(
                                  "span",
                                  { staticClass: "badge badge-info" },
                                  [_vm._v("Агент по продажам")]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          order.type_id === 4
                            ? _c("p", [
                                _c(
                                  "span",
                                  { staticClass: "badge badge-success" },
                                  [_vm._v("Запрос на звонок")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showStatus
                            ? _c("OrderStatus", {
                                attrs: { status: order.status },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          order.delivery_date
                            ? _c(
                                "span",
                                { staticClass: "badge badge-default" },
                                [
                                  _vm._v(
                                    "Доставка: " +
                                      _vm._s(
                                        _vm.moment(order.delivery_date, "DD.MM")
                                      )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          order.track_number || order.extra_options.post_track
                            ? _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        order.track_number ||
                                          order.extra_options.post_track
                                      ) +
                                      "\n          "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        target: "_blank",
                                        href: `https://www.pochta.ru/tracking#${
                                          order.track_number ||
                                          order.extra_options.post_track
                                        }`,
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon-fa icon-fa-info-circle",
                                      }),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.mixinIsAllowToEditOrder(order)
                            ? [
                                _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-xs btn-info newWindowBtn mr-1",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openOrderInModal(order.id)
                                        },
                                      },
                                    },
                                    [
                                      order.status === 0 &&
                                      !_vm.isOrderUnderManagerProgress(order.id)
                                        ? [
                                            _vm._v(
                                              "\n                взять в работу\n              "
                                            ),
                                          ]
                                        : order.status === 0 &&
                                          _vm.isOrderUnderManagerProgress(
                                            order.id,
                                            true
                                          )
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "time_ago_block" },
                                              [
                                                _c("OrderInProgressByManager", {
                                                  attrs: { orderId: order.id },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        : [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-eye",
                                            }),
                                          ],
                                    ],
                                    2
                                  ),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "div",
                            { staticClass: "flex justify-content-between" },
                            [
                              _c("p", [
                                order.client && order.client.comment
                                  ? _c("i", {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: {
                                            content: order.client.comment,
                                            placement: "bottom-center",
                                            classes: ["info custom-tooltip"],
                                            targetClasses: [
                                              "it-has-a-tooltip custom-tooltip",
                                            ],
                                            offset: 10,
                                            delay: {
                                              show: 200,
                                              hide: 700,
                                            },
                                          },
                                          expression:
                                            "{\n                  content: order.client.comment,\n                  placement: 'bottom-center',\n                  classes: ['info custom-tooltip'],\n                  targetClasses: ['it-has-a-tooltip custom-tooltip'],\n                  offset: 10,\n                  delay: {\n                    show: 200,\n                    hide: 700\n                  }\n                }",
                                        },
                                      ],
                                      staticClass:
                                        "icon-fa icon-fa-info-circle comment_tooltip_fa",
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.getClientName(order)) +
                                    "\n          "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          order.is_customer_trusted
                            ? _c("p", [
                                _c(
                                  "span",
                                  { staticClass: "badge badge-success" },
                                  [
                                    _vm._v(
                                      "постоянный (" +
                                        _vm._s(order.is_customer_trusted) +
                                        ")"
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.oldOrders && _vm.oldOrders[order.id]
                            ? _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.printOldData(
                                      "client",
                                      _vm.oldOrders[order.id]
                                    )
                                  ),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(order.order_phones || [], function (phone) {
                            return _c(
                              "div",
                              { key: phone.id, staticClass: "flex" },
                              [
                                _c(
                                  "div",
                                  [
                                    phone.comment
                                      ? _c("i", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: {
                                                content: phone.comment,
                                                placement: "bottom-center",
                                                classes: [
                                                  "info custom-tooltip",
                                                ],
                                                targetClasses: [
                                                  "it-has-a-tooltip custom-tooltip",
                                                ],
                                                offset: 10,
                                                delay: {
                                                  show: 200,
                                                  hide: 700,
                                                },
                                              },
                                              expression:
                                                "{\n                  content: phone.comment,\n                  placement: 'bottom-center',\n                  classes: ['info custom-tooltip'],\n                  targetClasses: ['it-has-a-tooltip custom-tooltip'],\n                  offset: 10,\n                  delay: {\n                    show: 200,\n                    hide: 700\n                  }\n                }",
                                            },
                                          ],
                                          staticClass:
                                            "icon-fa icon-fa-info-circle comment_tooltip_fa",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.mixinPrintPhone(
                                            phone?.phone?.phone ?? ""
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    phone &&
                                    phone.black_list &&
                                    phone.black_list.id
                                      ? [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "badge bg-dark pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openBlackListData(
                                                    phone.phone.full_phone
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("черный список")]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          !order.order_phones || !order.order_phones.length
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "flex" },
                                  [
                                    _c("strong", [_vm._v(_vm._s(order.phone))]),
                                    _vm._v(" "),
                                    _vm.editAvailable ||
                                    _vm.allowToEditByUser(order)
                                      ? void 0
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          order.extra_options?.noAnswerCallOrder
                            ? [
                                _c(
                                  "span",
                                  { staticClass: "badge badge-warning" },
                                  [
                                    _vm._v("недозвонов: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          order.extra_options.noAnswerCallOrder
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          (order.extra_options && order.extra_options.email) ||
                          (order.client && order.client.email)
                            ? _c("p", [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      order.extra_options.email ||
                                        (order.client && order.client.email)
                                    ) +
                                    "\n        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          false && !order.city_id
                            ? _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  order.letters && order.letters.length
                                    ? [
                                        _c("Letters", {
                                          attrs: { letters: order.letters },
                                        }),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "send_letter" }, [
                                    _c("i", {
                                      staticClass:
                                        "icon-fa icon-fa-share-square-o",
                                      on: {
                                        click: function ($event) {
                                          return _vm.onLetterModal(order)
                                        },
                                      },
                                    }),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.allowToHotCall
                            ? _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  order.is_agreed
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "badge badge-success",
                                          },
                                          [_vm._v("Согласовано")]
                                        ),
                                      ]
                                    : [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-xs btn-primary modal_call_btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.modalHotCall(order)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              Прозвон\n            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-xs btn-warning modal_call_btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.modalReject(order)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              Отмена\n            "
                                            ),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.allowToHotCall &&
                          order.extra_options &&
                          order.extra_options.callDeal
                            ? _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-xs btn-warning modal_call_btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.modalReject(
                                          order,
                                          "agreement"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            Отменить согласование\n          "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "w-20P relative" },
                        [
                          _c(
                            "div",
                            { staticClass: "chat_btn flex" },
                            [
                              order.dialogs && order.dialogs.length
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-default btn-sm",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getActiveDialogs(order.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon-fa icon-fa-weixin chat_icon",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (order.files ?? []).length
                                ? _c("AttachedFiles", {
                                    attrs: {
                                      files: order.files,
                                      hideText: true,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sendMessageModal[order.id].runner
                                ? _c(
                                    "div",
                                    {},
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-default btn-sm",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.sendTelegramMessage(
                                                order.id,
                                                "runnerModal"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "icon-fa icon-fa-motorcycle chat_icon",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.sendMessageModal[order.id].runnerModal
                                        ? _c("SendRunnerMessage", {
                                            attrs: {
                                              data: order,
                                              type: "runner",
                                              onModalClose: () =>
                                                (_vm.sendMessageModal[
                                                  order.id
                                                ].runnerModal = false),
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.printCity(order.city_id, order.type_id)
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            order.city_name
                              ? _c("span", [
                                  _vm._v("(" + _vm._s(order.city_name) + ")"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            order.division_id
                              ? _c(
                                  "strong",
                                  { staticClass: "division_label" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$AllDivisions[order.division_id]
                                          ?.title
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              order.city_id &&
                              order.address &&
                              order.address.length > 30
                                ? _c(
                                    "v-popover",
                                    {
                                      attrs: {
                                        "auto-hide": true,
                                        placement: "right",
                                        popoverClass:
                                          "order_address_map_popover",
                                        popoverInnerClass:
                                          "order_address_map_popover_inner",
                                        delay: { show: 500, hide: 500 },
                                      },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-xs btn-outline-info mr-1",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "icon-fa icon-fa-map-marker",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "template",
                                        { slot: "popover" },
                                        [
                                          _c("AddressMap", {
                                            attrs: {
                                              orderId: order.id,
                                              cityId: order.city_id,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(order.address))]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          order.extra_options?.address_details
                            ? _c("i", [
                                _vm._v(
                                  _vm._s(order.extra_options.address_details)
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.oldOrders && _vm.oldOrders[order.id]
                            ? _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.printOldData(
                                      "address",
                                      _vm.oldOrders[order.id]
                                    )
                                  ),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          order.extra_options && order.extra_options.post_index
                            ? _c("p", [
                                _vm._v(
                                  "\n          индекс: " +
                                    _vm._s(order.extra_options.post_index) +
                                    "\n        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          order.discount || order.delivery_price
                            ? _c("hr")
                            : _vm._e(),
                          _vm._v(" "),
                          order.discount
                            ? _c("p", [
                                _vm._v("\n          Скидка: "),
                                _c("strong", [_vm._v(_vm._s(order.discount))]),
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      order.discount_type == 1 ? "%" : "руб"
                                    ) +
                                    "\n          "
                                ),
                                order.currency_id && +order.discount_type === 0
                                  ? _c("span", [
                                      _vm._v(" ("),
                                      _c("strong", [
                                        _vm._v(_vm._s(order.currency_discount)),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$AllCurrencies[
                                              order.currency_id
                                            ]?.currency
                                          ) +
                                          ")"
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", [
                            order.delivery_price
                              ? _c("span", [
                                  _vm._v("Доставка: "),
                                  _c("strong", [
                                    _vm._v(_vm._s(order.delivery_price)),
                                  ]),
                                  _vm._v(" руб"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            order.currency_id && order.currency_delivery
                              ? _c("span", [
                                  _vm._v(" ("),
                                  _c("strong", [
                                    _vm._v(_vm._s(order.currency_delivery)),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$AllCurrencies[order.currency_id]
                                          ?.currency
                                      ) +
                                      ")"
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("RunnerSalaryRate", {
                            attrs: {
                              rate: order?.extra_options?.salary_rate ?? 0,
                            },
                          }),
                          _vm._v(" "),
                          order.courier && _vm.allowToShowRunner(order)
                            ? [
                                _c("hr"),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v("\n            курьер: "),
                                  _c("strong", [
                                    _vm._v(_vm._s(order.courier.name)),
                                  ]),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("td", { staticClass: "hidden" }, [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(_vm.printPhones(order)),
                          },
                        }),
                        _vm._v(" "),
                        order.extra_options && order.extra_options.email
                          ? _c("p", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(order.extra_options.email) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.allowToHotCall
                          ? _c(
                              "div",
                              { staticClass: "flex" },
                              [
                                order.is_agreed
                                  ? [
                                      _c(
                                        "span",
                                        { staticClass: "badge badge-success" },
                                        [_vm._v("Согласовано")]
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-xs btn-primary modal_call_btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.modalHotCall(order)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Прозвон\n            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-xs btn-warning modal_call_btn",
                                          on: {
                                            click: function ($event) {
                                              return _vm.modalReject(order)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Отмена\n            "
                                          ),
                                        ]
                                      ),
                                    ],
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.allowToHotCall &&
                        order.extra_options &&
                        order.extra_options.callDeal
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-xs btn-warning modal_call_btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.modalReject(order, "agreement")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            Отменить согласование\n          "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _vm._l(order.details ?? [], function (d, i) {
                            return d.type_id !== 1
                              ? [
                                  _c("DrugRecord", {
                                    attrs: { orderDetail: d, order: order },
                                  }),
                                  _vm._v(" "),
                                  i < order.details.length - 1
                                    ? _c("hr", { staticClass: "mb-1 mt-1" })
                                    : _vm._e(),
                                ]
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _vm.oldOrders && _vm.oldOrders[order.id]
                            ? _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.printOldData(
                                      "drugs",
                                      _vm.oldOrders[order.id]
                                    )
                                  ),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          order.extra_options &&
                          order.extra_options.pass_to_delivery_system
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "delivery_pass_details alert alert-info mb-0",
                                },
                                [
                                  _c("p", [
                                    _c("i", {
                                      class: {
                                        "icon-fa": true,
                                        "icon-fa-phone":
                                          +order.extra_options
                                            .pass_to_delivery_system.status ===
                                          9999,
                                        "icon-fa-internet-explorer":
                                          +order.extra_options
                                            .pass_to_delivery_system.status !==
                                          9999,
                                      },
                                    }),
                                    _vm._v(
                                      " \n            согласование\n            "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$AllProjects[
                                            order.extra_options
                                              .pass_to_delivery_system.site_id
                                          ] &&
                                            _vm.$AllProjects[
                                              order.extra_options
                                                .pass_to_delivery_system.site_id
                                            ].title
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n            выполнено " +
                                        _vm._s(
                                          _vm.printDate(
                                            order.extra_options
                                              .pass_to_delivery_system.date,
                                            "DD.MM.YYYY HH:mm",
                                            false,
                                            0
                                          )
                                        ) +
                                        "\n            " +
                                        _vm._s(
                                          order.extra_options
                                            .pass_to_delivery_system.user_name
                                        ) +
                                        "\n          "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm.editAvailable && _vm.changeSubStatus
                          ? _c("div", [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: order.sub_status,
                                      expression: "order.sub_status",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          order,
                                          "sub_status",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      function ($event) {
                                        return _vm.updateSubStatus(order)
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v("Не обрабатывалась"),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.subStatuses,
                                    function (status, index) {
                                      return _c(
                                        "option",
                                        { domProps: { value: index } },
                                        [
                                          _vm._v(
                                            _vm._s(status) + "\n            "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-xs btn-warning modal_call_btn",
                                    on: {
                                      click: function ($event) {
                                        return _vm.modalReject(
                                          order,
                                          "order",
                                          true
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              отменить заявку\n            "
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.createRefundAllow && order.type_id !== 2
                          ? _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-warning btn-xs",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openModal(order)
                                    },
                                  },
                                },
                                [_vm._v("\n            Возврат\n          ")]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          order.pay_method === 3
                            ? _c("p", [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: {
                                          content: _vm.getPrePaidData(order),
                                          placement: "bottom-center",
                                          classes: ["info custom-tooltip"],
                                          targetClasses: [
                                            "it-has-a-tooltip custom-tooltip",
                                          ],
                                          offset: 10,
                                          delay: {
                                            show: 200,
                                            hide: 700,
                                          },
                                        },
                                        expression:
                                          "{\n                content: getPrePaidData(order),\n                placement: 'bottom-center',\n                classes: ['info custom-tooltip'],\n                targetClasses: ['it-has-a-tooltip custom-tooltip'],\n                offset: 10,\n                delay: {\n                  show: 200,\n                  hide: 700\n                }\n              }",
                                      },
                                    ],
                                    class: {
                                      "badge pointer": true,
                                      "badge-warning":
                                        +order.price > +order.no_cash_price,
                                      "badge-success": !(
                                        +order.price > +order.no_cash_price
                                      ),
                                    },
                                  },
                                  [
                                    _c("i", {
                                      class: {
                                        "icon-fa icon-fa-credit-card": true,
                                      },
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(order.no_cash_price) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", { staticClass: "price_strong" }, [
                              _vm._v(_vm._s(order.price)),
                            ]),
                            _vm._v(" "),
                            order.currency_id &&
                            order.currency_id !==
                              _vm.$platformConstants.operationCurrency.id
                              ? _c("span", [
                                  _vm._v(" ("),
                                  _c("strong", [
                                    _vm._v(_vm._s(order.currency_id_price)),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$AllCurrencies[order.currency_id]
                                          ?.currency
                                      ) +
                                      ")"
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm.$currentRole == "admin" && _vm.newStoreData
                            ? _c(
                                "div",
                                [
                                  _vm._l(order.details, function (detail) {
                                    return _vm.debugDrug == detail.drug_id
                                      ? [
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.printStoreData(
                                                  detail.drug_id,
                                                  _vm.newStoreData.inStores[
                                                    detail.drug_id
                                                  ],
                                                  _vm.newStoreData.reservation[
                                                    detail.drug_id
                                                  ]
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      : _vm._e()
                                  }),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.oldOrders
                            ? _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.printOldData("new_price_syncro", order)
                                  ),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          order.no_cash_price && order.pay_method !== 3
                            ? _c("span", { staticClass: "badge badge-info" }, [
                                _vm._v("ожидается перевод"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          order.payment || order.pay_method === 3
                            ? [
                                _c("i", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: {
                                        content: _vm.getPrePaidData(order),
                                        placement: "bottom-center",
                                        classes: ["info custom-tooltip"],
                                        targetClasses: [
                                          "it-has-a-tooltip custom-tooltip",
                                        ],
                                        offset: 10,
                                        delay: {
                                          show: 200,
                                          hide: 700,
                                        },
                                      },
                                      expression:
                                        "{\n                content: getPrePaidData(order),\n                placement: 'bottom-center',\n                classes: ['info custom-tooltip'],\n                targetClasses: ['it-has-a-tooltip custom-tooltip'],\n                offset: 10,\n                delay: {\n                  show: 200,\n                  hide: 700\n                }\n              }",
                                    },
                                  ],
                                  staticClass:
                                    "icon-fa icon-fa-money payment_icon",
                                }),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex" }, [
                            _vm.oldOrders && _vm.oldOrders[order.id]
                              ? _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.printOldData(
                                        "price",
                                        _vm.oldOrders[order.id]
                                      )
                                    ),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.sendMessageModal[order.id].supervisor
                              ? _c(
                                  "div",
                                  { staticClass: "mr-1" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-default btn-sm",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.sendTelegramMessage(
                                              order.id,
                                              "supervisorModal"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "icon-fa icon-fa-user-secret chat_icon",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.sendMessageModal[order.id]
                                      .supervisorModal
                                      ? _c("SendRunnerMessage", {
                                          attrs: {
                                            data: order,
                                            type: "supervisor",
                                            onModalClose: () =>
                                              (_vm.sendMessageModal[
                                                order.id
                                              ].supervisorModal = false),
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.allowPrePaid(order)
                              ? _c(
                                  "div",
                                  [
                                    _c("PrePaidButton", {
                                      attrs: { order: order },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.disableEdit
                        ? _c(
                            "td",
                            [
                              _vm.ableToEdit && !_vm.editAvailable
                                ? [
                                    _c("div", { staticClass: "flex" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-xs btn-info newWindowBtn mr-1",
                                          on: {
                                            click: function ($event) {
                                              return _vm.openOrderInModal(
                                                order.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon-fa icon-fa-eye",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-info btn-xs",
                                          on: {
                                            click: function ($event) {
                                              return _vm.openEditOrderPage(
                                                order.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon-fa icon-fa-edit",
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e()
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _vm.modalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalData,
                expression: "modalData",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.updateSubStatusByModal,
              modalData: _vm.modalData,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.modalDataReject
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalDataReject,
                expression: "modalDataReject",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.rejectOrder,
              modalData: _vm.modalDataReject,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editComment && _vm.modalCommentData
        ? _c("editCommentModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalCommentData,
                expression: "modalCommentData",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              modalData: _vm.modalCommentData,
              updateOrder: _vm.updateOrderData,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }